var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('app-header',{on:{"scrollToMe":function($event){return _vm.handleScroll($event)}}}),_c('router-view',{attrs:{"link":this.link}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }